import { useLogger, useSwanStyleKeys, useUserContext } from '@vp/ubik-context'
import { WixAnonymousPlansApp } from '../web/wix-anonymous-plans-page/WixAnonymousPlansApp'
import { StyleKeys } from '../web/common/swanKeys'
import { useFeatureFlag } from '../common/hooks/useFeatureFlag'
import { featureFlagKeyEnum } from '../web/common/enums/experimentKey'

export const Fragment = (props: any) => {
  const logger = useLogger()
  const userContext = useUserContext()
  logger.log('Rendering fragment for a locale', userContext.locale)
  useSwanStyleKeys(StyleKeys)

  const isDomainSearchEnabled = useFeatureFlag(featureFlagKeyEnum.WIX_WEBSITES_DOMAIN_SUGGESTIONS_PP, [])

  const updatedProps = { ...props, isDomainSearchEnabled }

  return <WixAnonymousPlansApp {...updatedProps} />
}
